import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { RequestURLInterceptor } from "./requestUrl.inteceptor";

export const httpInterceptorproviders = [
    {provide: HTTP_INTERCEPTORS, useClass: RequestURLInterceptor, multi: true}
]